<template>
  <v-card class="pa-4" outlined>
    <div class="d-flex py-2">
      <v-spacer></v-spacer>
      <h3>Usuário</h3>
      <v-spacer></v-spacer>
      <v-btn icon absolute top right @click="$emit('close')">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </div>
    <v-divider class="my-4"></v-divider>

    <v-tabs v-model="tab" centered grow color="primary">
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>

      <v-tab class="rounded-lg rounded-b-0">Dados Gerais</v-tab>
      <v-tab class="rounded-lg rounded-b-0" v-if="user.mainType == 2">
        Acessos
      </v-tab>
    </v-tabs>

    <div style="max-height: 500px; overflow-y: auto">
      <v-tabs-items v-model="tab">
        <v-tab-item :value="0">
          <v-form ref="form">
            <v-row class="ma-0">
              <v-col cols="12" md="5">
                <label for="name">Nome</label>
                <v-text-field
                  hide-details="auto"
                  v-model="user.name"
                  name="name"
                  placeholder="Digite o nome do usuário"
                  :rules="[
                    (v) => !!v || 'Nome é obrigatório',
                    (v) => (v && v.length > 2) || 'Nome inválido',
                  ]"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <label for="name">E-mail</label>
                <v-text-field
                  hide-details="auto"
                  v-model="user.email"
                  :rules="[
                    (v) => !!v || 'E-mail é obrigatório',
                    (v) => (v && v.length > 2) || 'E-mail inválido',
                  ]"
                  name="email"
                  placeholder="Digite o e-mail do usuário"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                  @blur="getExistingUser"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label for="name">Telefone</label>
                <v-text-field
                  hide-details="auto"
                  v-model="user.phoneNumber"
                  v-mask="['(##) #####-####']"
                  placeholder="Digite o telefone do usuário"
                  name="observation"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" v-if="loggedUserType != 2">
                <label for="name">Tipo de usuário</label>
                <v-select
                  hide-details="auto"
                  single-line
                  :rules="[(v) => v != null || 'Tipo de usuário é obrigatório']"
                  :items="filteredUserTypes"
                  v-model="user.mainType"
                  placeholder="Selecione o tipo de usuário"
                  name="observation"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                ></v-select>
                <v-checkbox
                  v-if="loggedUserType === 0 || loggedUserType === 1"
                  v-model="user.isAte"
                  label="Usuário ATE"
                  hide-details="auto"
                  :disabled="loading"
                  class="mt-0"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" :sm="loggedUserType != 2 ? 2 : 6">
                <label>Status</label>
                <v-select
                  v-model="user.status"
                  :items="[
                    { text: $t('Ativo'), value: 0 },
                    { text: $t('Inativo'), value: 1 },
                  ]"
                  item-text="text"
                  item-value="value"
                  :rules="[(v) => v != null || 'Status é obrigatório']"
                  placeholder="Selecione o status"
                  hide-details="auto"
                  height="45"
                  append-icon="mdi-chevron-down"
                  name="email"
                  :disabled="loading || !isEditing"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6" v-if="!user.isSSO">
                <label class="label">{{ $t('Senha') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="user.password"
                  autocomplete="nope"
                  :rules="[
                    (v) => this.isEditing || !!v || 'Senha requerida',
                    (v) =>
                      !this.user.password ||
                      /\d/.test(v) ||
                      'Mínimo de um número',
                    this.user.password === '' || minLength(this.user.password),
                    this.user.password === '' ||
                      specialCharacters(this.user.password),
                    this.user.password === '' ||
                      uppercaseLetter(this.user.password),
                  ]"
                  type="password"
                  required
                  name="password"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                  :disabled="loading"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" v-if="!user.isSSO">
                <label class="label">{{ $t('Confirmação da senha') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="user.passwordConfirmation"
                  autocomplete="nope"
                  :rules="[
                    (v) =>
                      (this.isEditing && !this.user.password) ||
                      !!v ||
                      'Confirmação de senha é obrigatória',
                    (v) =>
                      !this.user.password ||
                      v === this.user.password ||
                      'Senha não confere',
                  ]"
                  type="password"
                  required
                  name="confirmPassword"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                  :disabled="loading"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="user.isSSO"
                  label="Apenas SSO"
                  hide-details="auto"
                  :disabled="loading"
                  class="mt-0"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <label for="name">Observação</label>
                <v-textarea
                  hide-details="auto"
                  v-model="user.remark"
                  name="observation"
                  placeholder="Digite a observação do usuário..."
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg"
                ></v-textarea>
              </v-col>

              <v-col cols="12" v-if="isEditing">
                <v-file-input
                  id="signature-input"
                  accept="image/png"
                  class="d-none"
                  @change="setSignatureImage"
                ></v-file-input>

                <label for="name">Assinatura</label>
                <v-card
                  height="137.5"
                  outlined
                  class="d-flex justify-center align-center signature-card pa-2"
                  @click="openPicker"
                >
                  <v-img
                    v-if="user.signatureImage"
                    :src="user.signatureImage"
                    contain
                    max-height="137.5"
                    height="100%"
                    rounded="lg"
                  ></v-img>
                  <v-icon v-else color="grey darken-1" size="40">
                    mdi-pencil
                  </v-icon>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>

        <v-tab-item>
          <v-expand-transition>
            <div
              class="my-1 pa-3"
              v-if="userInstitutions && userInstitutions.length > 0"
            >
              <label for="Pesquisar">Pesquisar acessos</label>
              <v-text-field
                hide-details="auto"
                v-model="search"
                name="search"
                placeholder="Digite o nome de uma instituição já adicionada..."
                :disabled="loading"
                append-icon="mdi-magnify"
                outlined
                background-color="#F5F5F5"
                class="rounded-lg mb-2"
              ></v-text-field>
            </div>
          </v-expand-transition>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <p class="text-center">
                    <strong>Novo acesso</strong>
                  </p>
                  <v-form ref="institution-form">
                    <label for="name">Instituição</label>
                    <v-autocomplete
                      v-model="selectedInstitution"
                      :items="institutions"
                      item-text="name"
                      item-value="id"
                      return-object
                      placeholder="Selecione a instituição"
                      hide-details="auto"
                      height="45"
                      append-icon="mdi-chevron-down"
                      name="email"
                      :rules="[
                        (v) => !!v || 'Instituição é obrigatória',
                        (v) =>
                          this.userInstitutions.find(
                            (institution) =>
                              institution &&
                              v &&
                              institution.institutionId === v.id
                          ) === undefined || 'Instituição já adicionada',
                      ]"
                      :disabled="institutionLoading || loading"
                      outlined
                      background-color="#F5F5F5"
                      class="rounded-lg mb-2"
                    ></v-autocomplete>
                    <v-btn
                      class="ma-0 mt-4 secondary-button"
                      depressed
                      block
                      :loading="institutionLoading || loading"
                      @click="addInstitution"
                    >
                      Adicionar Acesso
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-for="(institution, i) in userInstitutions.filter(
                (x) =>
                  (!search ||
                    (x.name &&
                      x.name.toLowerCase().includes(search.toLowerCase()))) &&
                  x.show
              )"
              :key="i"
            >
              <v-card
                class="pa-4 d-flex flex-column"
                outlined
                rounded="lg"
                height="100%"
              >
                <div>
                  <div class="d-flex justify-center">
                    <v-avatar
                      size="40"
                      class="mr-2"
                      v-if="institution.logoPath"
                    >
                      <v-img :src="institution.logoPath" contain></v-img>
                    </v-avatar>
                    <p v-else>
                      <v-icon size="30" color="grey darken-1"
                        >mdi-domain</v-icon
                      >
                    </p>
                  </div>

                  <p class="text-center" style="word-break: keep-all">
                    <b>{{ institution.name }}</b>
                  </p>
                </div>

                <v-spacer></v-spacer>

                <v-form :ref="`user-institution-form` + i">
                  <div>
                    <label for="name">Tipo de Acesso</label>
                    <v-select
                      v-model="institution.userType"
                      :items="types"
                      item-text="text"
                      item-value="value"
                      placeholder="Selecione o tipo de acesso"
                      hide-details="auto"
                      height="45"
                      append-icon="mdi-chevron-down"
                      name="email"
                      :disabled="loading"
                      outlined
                      background-color="#F5F5F5"
                      class="rounded-lg mb-2"
                    >
                      <template v-slot:item="{ item }">
                        <v-tooltip right max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-list-item-content v-bind="attrs" v-on="on">
                              <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <span>{{ item.tooltip }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </div>

                  <div>
                    <label for="name">Cargo</label>
                    <v-select
                      v-model="institution.userOffice"
                      :items="offices"
                      item-text="text"
                      item-value="value"
                      placeholder="Selecione o cargo"
                      hide-details="auto"
                      height="45"
                      append-icon="mdi-chevron-down"
                      name="email"
                      :disabled="loading"
                      outlined
                      background-color="#F5F5F5"
                      class="rounded-lg mb-2"
                    ></v-select>
                  </div>

                  <div>
                    <label for="name">Data de admissão</label>

                    <v-menu
                      :ref="`${institution.id}`"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          v-model="institution.admissionDateAux"
                          v-mask="['##/##/####']"
                          placeholder="Selecione a data de admissão"
                          prepend-inner-icon="mdi-calendar"
                          :rules="[
                            (v) => !!v || 'Data de admissão é obrigatória',
                            (v) =>
                              !v || !!parseDate(v) || 'Data de admissão inválida',
                          ]"
                          @blur="
                            institution.admissionDate = parseDate(
                              institution.admissionDateAux
                            )
                          "
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          background-color="#F5F5F5"
                          class="rounded-lg mb-2"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="institution.admissionDate"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1900-01-01"
                        no-title
                        @change="save(institution, $event)"
                      ></v-date-picker>
                    </v-menu>
                  </div>

                  <div>
                    <label for="name">Valor Homem-Hora</label>
                    <vuetify-money
                      v-model="institution.manHourCost"
                      placeholder="Valor Homem-Hora"
                      outlined
                      hide-details="auto"
                      background-color="#F5F5F5"
                      class="rounded-lg mb-1"
                    ></vuetify-money>
                  </div>

                  <div>
                    <label for="name">Celular</label>
                    <v-text-field
                      v-model="institution.cellPhoneNumber"
                      v-mask="['(##) #####-####']"
                      placeholder="Celular"
                      :rules="[
                        (v) => !!v || 'Celular requerido',
                        (v) => (v && v.length > 14) || 'Celular inválido',
                      ]"
                      outlined
                      hide-details="auto"
                      background-color="#F5F5F5"
                      class="rounded-lg mb-1"
                    ></v-text-field>
                  </div>

                  <div>
                    <label for="name">Unidades</label>
                    <v-select
                      v-model="institution.unidades"
                      :items="
                        unidades.filter(
                          (x) =>
                            x.institutionId ==
                            (institution.institutionId ?? institution.id)
                        )
                      "
                      multiple
                      item-text="name"
                      item-value="id"
                      placeholder="Selecione a unidade"
                      hide-details="auto"
                      append-icon="mdi-chevron-down"
                      name="email"
                      :disabled="loading"
                      outlined
                      background-color="#F5F5F5"
                      class="rounded-lg mb-2"
                    >
                      <template
                        v-slot:selection="{
                          attrs,
                          item,
                          select,
                          selected,
                          index,
                        }"
                      >
                        <v-chip
                          v-if="index === 0"
                          v-bind="attrs"
                          :input-value="selected"
                          color="#BBCF20"
                          text-color="#fff"
                          small
                          @click="select"
                        >
                          {{ item.name }}
                        </v-chip>
                        <span
                          v-if="institution.unidades && index === 1"
                          class="grey--text text-caption"
                          style="font-size: 0.8rem"
                        >
                          ( +{{ institution.unidades.length - 1 }})
                        </span>
                      </template>
                    </v-select>
                  </div>
                </v-form>

                <v-spacer></v-spacer>

                <v-btn
                  block
                  color="error"
                  max-height="40"
                  depressed
                  class="my-1 rounded-lg"
                  @click="removeInstitution(institution.id)"
                >
                  Remover
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-divider class="my-4"></v-divider>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        class="ma-0 secondary-button"
        depressed
        :loading="loading"
        @click="submit"
      >
        Salvar
      </v-btn>
    </div>
    <v-dialog v-model="confirmModal" max-width="500px" persistent>
      <v-card class="pa-4">
        <div class="d-flex align-center mb-4">
          <v-spacer></v-spacer>
          <h3>Adicionar usuário à instituição?</h3>
          <v-spacer></v-spacer>
        </div>
        <v-divider class="mb-4"></v-divider>
        <div class="text-center mb-6">
          <span class="subtitle-1">
            Já existe um usuário com este e-mail.<br />
            Deseja adicionar o usuário à instituição atual?
          </span>
        </div>
        <div class="d-flex justify-center">
          <v-btn
            color="grey lighten-1"
            class="mx-2 px-6"
            @click="cancelInstitutionAdd"
            depressed
          >
            Não
          </v-btn>

          <v-btn
            color="primary"
            class="mx-2 px-6"
            @click="openInstitutionModal"
            depressed
          >
            Sim
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <UserInstitutionModal
      v-model="showInstitutionModal"
      :user-institutions="userInstitutions"
      :types="types"
      :localUserId="localUserId"
      @remove-institution="removeInstitution"
      @close="cancelInstitutionAdd"
      @closeall="handleFullClose"
    />
  </v-card>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import UserInstitutionModal from './userRegister.vue'
import moment from 'moment'

export default {
  name: 'ManageUsers',

  props: {
    userId: String,
  },

  components: {
    UserInstitutionModal,
  },

  data() {
    return {
      search: '',
      admissionDate: null,
      selectedInstitution: null,
      tab: 0,
      userInstitutions: [],
      apiService: new ApiService(),
      user: {
        status: null,
        signatureImage: null,
        mainType: 2,
        isAte: false,
      },
      loading: false,
      institutions: [],
      institutionLoading: false,
      offices: [
        { text: 'Auxiliar', value: 0 },
        { text: 'Coordenador', value: 1 },
        { text: 'Enfermeiro', value: 2 },
        { text: 'Engenheiro', value: 3 },
        { text: 'Estagiário', value: 4 },
        { text: 'Recepcionista', value: 5 },
        { text: 'Supervisor', value: 6 },
        { text: 'Técnico', value: 7 },
        { text: 'Farmacêutico', value: 8 },
        { text: 'Fisioterapeuta', value: 9 },
        { text: 'Administrativo', value: 10 },
        { text: 'Gerente', value: 11 },
        { text: 'Nutricionista', value: 12 },
      ],
      types: [
        { text: 'Supervisor Principal', value: 8, tooltip: 'Acesso total ao sistema, incluindo configurações administrativas e gestão de usuários.' },
        { text: 'Supervisor', value: 2, tooltip: 'Acesso amplo à operação da instituição. Pode criar, editar, inativar equipamentos e gerenciar todos os módulos operacionais, relatórios, usuários, chat e alertas.' },
        { text: 'Operador', value: 3, tooltip: 'Execução técnica. Acessa os principais módulos operacionais, mas sem funções administrativas como gestão de usuários, configurações do sistema ou alertas da barra de topo.' },
        { text: 'Coordenador Op.', value: 4, tooltip: 'Coordenação operacional com acesso em modo visualização. Botões de criar, editar e fechar estão desabilitados na maioria das páginas. Não acessa Big Data, Usuários nem Repositório de Arquivos.' },
        { text: 'Coordenador Setor Assistencial', value: 5, tooltip: 'Perfil voltado ao setor clínico/assistencial. Acesso restrito a Equipamentos, OS, Chamados, Manutenção Programada, Dashboard e Agendamentos. Não acessa Estoque, Relatórios completos, Big Data, Usuários nem módulos administrativos.' },
        { text: 'Solicitador', value: 6, tooltip: 'Perfil mais restrito. Destinado a quem apenas abre chamados. Não acessa Equipamentos, OS, Manutenção, Estoque, Relatórios, Big Data, Chat nem Alertas.' },
      ],
      mainTypes: [],
      unidades: [],
      isEditing: false,
      loggedUserType: null,
      institutionId: null,
      showInstitutionModal: false,
      confirmModal: false,
      localUserId: null,
      loggedUser: {},
    }
  },

  async created() {
    this.loggedUser = JSON.parse(localStorage.getItem('user'))
    this.loggedUserType = JSON.parse(localStorage.getItem('user')).mainType
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    this.getInstitutions()

    if (this.loggedUser.mainType == 2) {
      if (institution.userType == 2) {
        this.types = this.types.filter(
          (type) => type.value < 8 && type.value >= 2
        )
      } else if (institution.userType == 8) {
        this.types = this.types.filter(
          (type) => type.value < 8 && type.value >= 2
        )
      }
    }

    if (this.userId) {
      this.isEditing = true
      await this.getUser()
    }
    if (!this.isEditing) {
      this.user.status = 0

      if (this.loggedUser.mainType == 2) {
        this.userInstitutions.push({
          ...institution,
          institutionId: this.institutionId,
          institution,
          userType: 2,
          userOffice: 0,
          admissionDate: null,
          manHourCost: null,
          show: true,
        })
      }
    }

    await this.getUnidades()
  },

  watch: {
    'user.isSSO'(val) {
      if (this.isEditing) return
      if (val) {
        this.generateRandomPassword()
      } else {
        this.user.password = ''
        this.user.passwordConfirmation = ''
      }
    },
  },

  computed: {
    filteredUserTypes() {
      const allTypes = [
        { text: 'Master', value: 0 },
        { text: 'Administrador', value: 1 },
        { text: 'Usuário', value: 2 },
      ]

      switch (this.loggedUserType) {
        case 0:
          return allTypes
        case 1:
          return allTypes.filter((type) => type.value !== 0)
        case 2:
          return allTypes.filter((type) => type.value !== 0 && type.value !== 1)
        default:
          return allTypes
      }
    },
  },

  methods: {
    resetForm() {
      this.user = {
        name: '',
        email: '',
        phoneNumber: '',
        mainType: null,
        status: null,
        password: '',
        passwordConfirmation: '',
        remark: '',
        signatureImage: null,
        institutions: [],
      }

      this.userInstitutions = []

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      })
    },

    minLength(v) {
      if (v && v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caracteres'
        }
      }
      return true
    },

    specialCharacters(v) {
      if (v && v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v && v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiúscula'

        return true
      }
      return true
    },
    openPicker() {
      document.getElementById('signature-input').click()
    },

    setSignatureImage(file) {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (evt) => {
        this.user.signatureImage = evt.target.result
        this.user.fileType = file.type.split('/')[1]
      }
    },

    save(institution, date) {
      institution.admissionDateAux = this.formatInputDate(
        institution.admissionDate
      )
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate(date) {
      const parsed = moment(date, 'DD/MM/YYYY', true)

      return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null
    },

    getExistingUser() {
      if (!this.user.email || this.user.email.trim() === '') return

      if (this.isEditing) return

      const payload = {
        email: this.user.email,
        institutionId: this.institutionId,
      }
      this.apiService
        .post('user/get-existing-user', payload)
        .then((response) => {
          if (
            response.statusCode === 200 &&
            response.content?.hasAccess === false
          ) {
            this.localUserId = response.content.id
            this.openConfirmModal()
          }
          if (
            response.statusCode === 200 &&
            response.content?.hasAccess === true
          ) {
            this.$toast.error(
              'Já existe um usuário com este e-mail cadastrado nesta instituição.'
            )
          }
        })
    },

    async getUnidades() {
      const institutionIds = this.userInstitutions.map(
        (institution) => institution.institutionId ?? institution.id
      )

      await this.apiService
        .post('unidade/listByIntitutionIds', { ids: institutionIds })
        .then((response) => {
          this.unidades = response.content
        })
        .catch(() => {})
    },

    async getUser() {
      this.loading = true

      await this.apiService
        .get(`user/${this.userId}`)
        .then((response) => {
          this.user = response.content
          this.loading = false
          this.userInstitutions = response.content.institutions.map(
            (institution) => {
              return {
                ...institution.institution,
                ...institution,
                admissionDate: institution.admissionDate
                  ? moment.parseZone(institution.admissionDate).format('YYYY-MM-DD')
                  : null,
                admissionDateAux: institution.admissionDate
                  ? moment.parseZone(institution.admissionDate).format('DD/MM/YYYY')
                  : null,
                unidades: institution.unidades.map((unidade) => {
                  return unidade.unidadeId
                }),
                show: true,
              }
            }
          )

          console.log(this.userInstitutions)

          if (this.loggedUser.mainType > 1) {
            this.userInstitutions = this.userInstitutions.map((institution) => {
              if (
                this.institutions.find((x) => x.id == institution.institutionId)
              ) {
                return {
                  ...institution,
                  show: true,
                }
              }
              return {
                ...institution,
                show: false,
              }
            })
          }

          console.log(this.userInstitutions)
        })
        .catch(() => {
          this.loading = false
        })
    },

    removeInstitution(id) {
      this.userInstitutions = this.userInstitutions.filter(
        (institution) => institution.id !== id
      )

      this.getUnidades()
    },

    addInstitution() {
      if (!this.$refs[`institution-form`].validate()) return

      this.selectedInstitution.institutionId = this.selectedInstitution.id

      this.userInstitutions.push({ ...this.selectedInstitution, show: true })
      this.selectedInstitution = null
      this.$refs['institution-form'].reset()

      this.getUnidades()
    },

    add() {
      this.loading = true

      if (this.user.mainType == 2 && this.user.institutions.length == 0) {
        this.$toast.error('Usuário deve ter ao menos uma instituição.')
        this.loading = false
        return
      }

      this.apiService
        .post('user/register', this.user)
        .then((response) => {
          if (response.statusCode == 200) {
            this.loading = false
            this.$toast.success('Usuário cadastrado! Já pode acessar o Fix 👋')
            this.$emit('close')
          } else {
            this.loading = false
            this.$toast.error(response.message)
          }
        })
        .catch((error) => {
          if (error.response?.data?.message) {
            this.$toast.error(error.response.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.apiService
        .post(`user/edit`, this.user)
        .then((response) => {
          if (response.statusCode == 200) {
            this.loading = false
            this.$toast.success('Usuário atualizado!')
            this.$emit('close')
          } else {
            this.loading = false
            this.$toast.error(response.message)
          }
        })
        .catch((error) => {
          if (error.response?.message) {
            this.$toast.error(error.response.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      if (this.user.mainType == 2) {
        const visibleInstitutions = this.userInstitutions.filter((x) => x.show)

        for (let i = 0; i < visibleInstitutions.length; i++) {
          const formRef = this.$refs[`user-institution-form${i}`]
          if (formRef && formRef[0] && !formRef[0].validate()) {
            this.tab = 1

            this.$nextTick(() => {
              const cardElements = document.querySelectorAll(
                '.v-card.pa-4.d-flex.flex-column'
              )
              if (cardElements[i + 1]) {
                cardElements[i + 1].scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                })
              }
            })

            this.$toast.error(
              'Por favor, preencha todos os campos obrigatórios na aba de Acessos'
            )
            return
          }
        }
      }

      this.user.institutions = this.userInstitutions.map((institution) => {
        return {
          institutionId: institution.institutionId ?? institution.id,
          userType: institution.userType,
          userOffice: institution.userOffice,
          admissionDate: institution.admissionDate,
          manHourCost: institution.manHourCost,
          cellPhoneNumber: institution.cellPhoneNumber,
          unidades: institution.unidades.map((id) => {
            return { unidadeId: id }
          }),
        }
      })

      if (this.isEditing) {
        this.edit()
      } else {
        this.add()
      }
    },

    generateRandomPassword() {
      const length = 12
      const lowercase = 'abcdefghijklmnopqrstuvwxyz'
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const digits = '0123456789'
      const specials = "!@#$%^&*()_+[]{};:'\"<>,.?/~\\-"
      const charset = lowercase + uppercase + digits + specials

      const pick = (chars) =>
        chars.charAt(Math.floor(Math.random() * chars.length))

      const required = [pick(uppercase), pick(digits), pick(specials)]

      let password = required.join('')
      for (let i = password.length; i < length; ++i) {
        password += pick(charset)
      }

      password = password
        .split('')
        .sort(() => Math.random() - 0.5)
        .join('')

      this.user.password = password
      this.user.passwordConfirmation = password
    },

    getInstitutions() {
      this.institutionLoading = true
      this.apiService
        .get('institution/list-with-user-type')
        .then((response) => {
          this.institutionLoading = false
          this.institutions = response.content
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },
    openConfirmModal() {
      if (!this.isEditing) {
        this.confirmModal = true
      }
    },
    openInstitutionModal() {
      this.confirmModal = false
      this.showInstitutionModal = true
    },
    cancelInstitutionAdd() {
      this.showInstitutionModal = false
      this.confirmModal = false
      this.resetForm()
    },
    handleFullClose() {
      this.cancelInstitutionAdd()
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.signature-card {
  min-width: 200px;
  transition: 0.3s;
  background-color: #f5f5f5;
}

.signature-card:hover {
  cursor: pointer;
  background-color: #e9e9e9;
}
</style>
